import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import detector from 'i18next-browser-languagedetector'
import {getTheme} from 'theme'

import {isLoginApp, isProfileApp, isConsentApp, isTest} from 'utils/envUtils'
import {getLang, isDebugMode} from 'utils/stringUtils'
import {ALL_LANGUAGES} from 'const'

const lang = getLang(window.location.search) || 'de'
const fallbackLng = ALL_LANGUAGES.includes(lang) ? lang : 'de'

let appNS

switch (true) {
  case isLoginApp():
    appNS = 'hosted_app'
    break
  case isProfileApp():
    appNS = 'profile_app'
    break
  case isConsentApp():
    appNS = 'consent_app'
    break
  default:
    appNS = 'profile_app'
}

const brand = getTheme(window).brand.name
const brandNS = `${brand}/${appNS}`
const brandCommon = `${brand}/common`

i18n
  .use(Backend)
  .use(detector)
  .init({
    fallbackLng: isProfileApp() ? 'de' : fallbackLng,
    supportedLngs: ALL_LANGUAGES,
    load: 'languageOnly',
    ns: isProfileApp() ? [appNS, 'common', brandCommon] : [appNS, 'common', brandNS, brandCommon],
    defaultNS: brandNS,
    debug: isDebugMode(),
    preload: isProfileApp() ? ['de', 'fr'] : ['de'],
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    fallbackNS: [brandCommon, 'common', appNS],
    // react i18next special options (optional)
    react: {
      wait: !isTest(),
      nsMode: 'default',
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage'],
      lookupQuerystring: 'lang',
      lookupCookie: 'lang',
      lookupLocalStorage: 'lang',
      caches: ['cookie', 'localStorage'],
      cookieOptions: {
        domain: process.env.REACT_APP_OVERRIDE_DOMAIN,
        path: '/',
        sameSite: 'none',
        secure: true,
      },
    },
    backend: {
      queryStringParams: {
        v: process.env.REACT_APP_TRANSLATION_VERSION,
      },
      crossDomain: true,
      loadPath: `${process.env.REACT_APP_PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
    },
  })

i18n.on('languageChanged', lang => document.documentElement.setAttribute('lang', lang))

export default i18n
